import { createStore, Store, useStore as useVuexStore } from 'vuex'
import { IRootState, IStore } from './types'

import login from './login/login'
import system from './main/system/system'
import dashboard from './main/analysis/dashboard'

import { getPageListData } from '@/service/main/system/system'
const store = createStore<IRootState>({
  state() {
    return {
      name: 'coderwhy',
      age: 18,
      entireDepartments: [],
      entireRoles: [],
      entireMenus: []
    }
  },
  getters: {},
  mutations: {
    changeEntireDepartments(state, list) {
      state.entireDepartments = list
    },
    changeEntireRoles(state, list) {
      state.entireRoles = list
    },
    changeEntireMenus(state, list) {
      state.entireMenus = list
    }
  },
  actions: {
    async getInitDataAction({ commit }) {
      // 部门信息
      const departmentResult = await getPageListData('/department/list', {
        offset: 0,
        size: 1000
      })

      const { list: departmentList } = departmentResult.data

      // 角色信息
      const roleResult = await getPageListData('/role/list', {
        offset: 0,
        size: 1000
      })
      const { list: roleList } = roleResult.data

      // 获取所有的menu
      const menuResult = await getPageListData('/menu/list', {})
      const { list: menuList } = menuResult.data

      // 保存数据
      commit('changeEntireDepartments', departmentList)
      commit('changeEntireRoles', roleList)
      commit('changeEntireMenus', menuList)
    }
  },
  modules: { login, system, dashboard }
})

export default store
export function setupStore() {
  store.dispatch('login/loadLocalLogin')
  // 此处可能会有问题
  // store.dispatch('getInitDataAction')
}

export function useStore(): Store<IStore> {
  return useVuexStore()
}
